export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

let capturedInstallPrompt: BeforeInstallPromptEvent | null = null
const promptListeners = new Set<(event: BeforeInstallPromptEvent) => void>()

function bindEarlyInstallPromptCapture() {
  if (typeof window === 'undefined') {
    return
  }

  const globalWindow = window as Window & { __pwaInstallBound?: boolean }

  if (globalWindow.__pwaInstallBound) {
    return
  }

  globalWindow.__pwaInstallBound = true

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    const promptEvent = event as BeforeInstallPromptEvent
    capturedInstallPrompt = promptEvent
    promptListeners.forEach((listener) => listener(promptEvent))
  })
}

bindEarlyInstallPromptCapture()

export function getCapturedInstallPrompt() {
  return capturedInstallPrompt
}

export function clearCapturedInstallPrompt() {
  capturedInstallPrompt = null
}

export function subscribeInstallPrompt(listener: (event: BeforeInstallPromptEvent) => void) {
  if (capturedInstallPrompt) {
    listener(capturedInstallPrompt)
  }

  promptListeners.add(listener)

  return () => {
    promptListeners.delete(listener)
  }
}
